export default __webpack_public_path__ + "static/media/MaraLovelace.a526d4bd.png";